import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseElement, customElement } from '../../../components';
import folderAccessIcon from '../../../assets/folder-access.svg?url';
import styles from './no-project-access.scss?inline';

@customElement('ps-no-project-access')
export class NoProjectAccessWC extends BaseElement {
  static styles = unsafeCSS(styles);

  @property() projectName: string = '';

  render() {
    return html`
      <div class="c-no-project-access__container">
        <ps-stack direction="column" alignItems="center" gutter="2xsmall">
          <ps-image
            src=${folderAccessIcon}
            alt="Folder access icon"
            width="180"
          ></ps-image>
          <ps-spacer size="xlarge"></ps-spacer>
          <ps-text-title size="small" textAlign="center"
            >You don’t have access to the project
            ${this.projectName}</ps-text-title
          >
          <ps-spacer size="2xsmall"></ps-spacer>
          <ps-text-subtitle size="medium" variant="secondary" textAlign="center"
            >Contact an admin or manage your access.</ps-text-subtitle
          >
          <ps-spacer size="xlarge"></ps-spacer>
          <ps-stack justifyContent="center">
            <ps-button size="xlarge" variant="secondary">
              <ps-icon slot="prefix" name="avatar" size="xsmall"></ps-icon>
              My Account
            </ps-button>
            <ps-button size="xlarge">
              <ps-icon slot="prefix" name="home" size="xsmall"></ps-icon>
              Home
            </ps-button>
          </ps-stack>
        </ps-stack>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-no-project-access': NoProjectAccessWC;
  }
}
